import { createFileRoute } from '@tanstack/react-router'

import WriteAdminProvinsiPage from '@/components/pages/backoffice/_user/_provinsi/containers/WriteAdminProvinsi'

export const Route = createFileRoute(
  '/_backoffice/user/provinsi/$adminId/edit'
)({
  component: AdminProvinceEditPage
})

function AdminProvinceEditPage() {
  const { adminId } = Route.useParams()

  return <WriteAdminProvinsiPage type="edit" userId={adminId} />
}
